import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../../../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { MatDialog } from "@angular/material/dialog";
import { formatDate } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "src/app/services/notification.service";

@Component({
  selector: "sm-upcoming-appointments",
  templateUrl: "./upcoming-appointments.component.html",
  styleUrls: ["./upcoming-appointments.component.scss"],
})
export class UpcomingAppointmentsComponent implements OnInit, OnDestroy {
  repeatArray: any;
  upcomingCount: any = {};
  upcomingAppointmentsData: any = [];
  toshowData: boolean = true;
  loader: boolean = false;
  _apisub: Subscription;
  constructor(
    private _apiservice: ApiService,
    private router: Router,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private _snackBar: MatSnackBar,
    private zone: NgZone
  ) {
    this.listenForNewBookingUpdates();
    this.listenForBookingStatusUpdates();
    this.listenForMemberAttendance();
    this.listenForMemberBookingStatusUpdate();
    this.listenForBookingAssignmentUpdates();
    this.listenForMemberBookingAssignmentUpdates();
    this._apisub = this._apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_UPCOMING_BOOKINGS_FOR_DASHBOARD_COUNT
      ) {
        this.upcomingCount = {};
        if (resdata.result) {
          this.upcomingCount = resdata.result;
        }

        this.loader = false;
      }
    });
  }

  ngOnInit(): void {
    this.loader = true;
    this._apiservice.getUpcomingBookingsCountForDashboard("4", "1");
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update if tomorrows bookings
              // this.loader = true;
              this._apiservice.getUpcomingBookingsCountForDashboard("4", "1");

            }
          })
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
            console.log("New notification received:", payload);
            payload.data.misc =
              typeof payload.data.misc == "string"
                ? JSON.parse(payload.data.misc)
                : payload.data.misc;
                if (true) {
                  //check and update if tomorrows bookings
                    // this.loader = true;
                    this._apiservice.getUpcomingBookingsCountForDashboard("4", "1");
      
                  }
              
          })
        }
      });
  }
  private bookingAssignmentsubscription: Subscription = new Subscription();
  listenForBookingAssignmentUpdates() {
    this.bookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onCustomerAssign")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
            console.log("New notification received:", payload);
            payload.data.misc =
              typeof payload.data.misc == "string"
                ? JSON.parse(payload.data.misc)
                : payload.data.misc;
                if (true) {
                  //check and update if tomorrows bookings
                    // this.loader = true;
                    this._apiservice.getUpcomingBookingsCountForDashboard("4", "1");
      
                  }
              
          })
        }
      });
  }

  private memberattendancesubscription: Subscription = new Subscription();
  listenForMemberAttendance() {
    this.memberattendancesubscription = this.notificationService
      .getNotificationByType("onMemberAttendance")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
            console.log("New notification received:", payload);
            payload.data.misc =
              typeof payload.data.misc == "string"
                ? JSON.parse(payload.data.misc)
                : payload.data.misc;
                if (true) {
                  //check and update if tomorrows bookings
                    // this.loader = true;
                    this._apiservice.getUpcomingBookingsCountForDashboard("4", "1");
      
                  }
              
          })
        }
      });
  }

  private memberbookingstatuschangedsubscription: Subscription =
    new Subscription();
  listenForMemberBookingStatusUpdate() {
    this.memberbookingstatuschangedsubscription = this.notificationService
      .getNotificationByType("memberBookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
            console.log("New notification received:", payload);
            payload.data.misc =
              typeof payload.data.misc == "string"
                ? JSON.parse(payload.data.misc)
                : payload.data.misc;
                if (true) {
                  //check and update if tomorrows bookings
                    // this.loader = true;
                    this._apiservice.getUpcomingBookingsCountForDashboard("4", "1");
      
                  }
              
          })
        }
      });
  }
  private memberBookingAssignmentsubscription: Subscription =
    new Subscription();
  listenForMemberBookingAssignmentUpdates() {
    this.memberBookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onMemberAssign")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
            console.log("New notification received:", payload);
            payload.data.misc =
              typeof payload.data.misc == "string"
                ? JSON.parse(payload.data.misc)
                : payload.data.misc;
                if (true) {
                  //check and update if tomorrows bookings
                    // this.loader = true;
                    this._apiservice.getUpcomingBookingsCountForDashboard("4", "1");
      
                  }
              
          })
        }
      });
  }

  viewAll() {
    if (this.upcomingCount?.total_bookings > 0) {
      this.router.navigate(["all-upcoming-appointments"]);
    }
  }

  ngOnDestroy(): void {
    this._apisub.unsubscribe();
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
    if (this.memberattendancesubscription) {
      this.memberattendancesubscription.unsubscribe();
    }
    if (this.memberbookingstatuschangedsubscription) {
      this.memberbookingstatuschangedsubscription.unsubscribe();
    }
    if (this.bookingAssignmentsubscription) {
      this.bookingAssignmentsubscription.unsubscribe();
    }
    if (this.memberBookingAssignmentsubscription) {
      this.memberBookingAssignmentsubscription.unsubscribe();
    }
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Upcoming bookings",
      },
    });
  }
}
